import { calcDuration, numFormatter } from "@unisearch/helpers";
import Link from "next/link";
import { AiOutlineCalendar, AiOutlineClockCircle } from "react-icons/ai";
import { BsCashStack } from "react-icons/bs";
import { FiFileText } from "react-icons/fi";
import { IoMdSchool } from "react-icons/io";
import styles from "./course_card.module.scss";

export const CourseCard = ({
  link,
  name,
  level,
  exams,
  session,
  duration,
  month,
  year,
  amountFrom,
  amountTo,
  countryCurrency,
  intakes,
  isAlignRow,
  ...porps
}) => {
  const intakeArray =
    intakes?.length > 0
      ? intakes?.sort((a, b) => a.intakeYear - b.intakeYear)
      : [];

  return (
    <div
      className={`${styles.course_card} ${isAlignRow ? styles.align_row : ""}`}
    >
      <Link legacyBehavior href={link}>
        <a target="_blank" rel="noopener noreferrer">
          <h3 className={styles.course_card_title}>{name}</h3>
        </a>
      </Link>
      <ul className={styles.course_card_info_lists}>
        <li>
          <IoMdSchool className={styles.course_card_icon} />
          <div className={styles.course_card_text}>
            <span>Course Level</span>
            <span>{level}</span>
          </div>
        </li>

        {duration && (
          <li>
            <AiOutlineClockCircle className={styles.course_card_icon} />
            <div className={styles.course_card_text}>
              <span>Course Duration</span>
              <span className={styles.card_text_last}>
                {calcDuration(duration)}
              </span>
            </div>
          </li>
        )}

        <li>
          <BsCashStack
            style={{ fontSize: "15px" }}
            className={styles.course_card_icon}
          />
          <div className={styles.course_card_text}>
            <span>1st Year Tution Fees</span>
            <span className={styles.card_text_last}>
              {countryCurrency} {amountFrom ? numFormatter(amountFrom) : ""}
              {amountTo && amountTo != 0 && " - " + numFormatter(amountTo)}
            </span>
          </div>
        </li>

        {intakes && intakes?.length > 0 && (
          <li>
            <AiOutlineCalendar className={styles.course_card_icon} />
            <div className={styles.course_card_text}>
              <div className={styles.more_intake_wrapper}>
                <span>Intake</span>

                {intakeArray?.length > 1 && (
                  <div className={`${styles.more_intake} relative`}>
                    <span className={styles.more_intake_num}>
                      +{intakeArray.length - 1}
                    </span>
                    <div className="uni-tooltip top">
                      {intakeArray.slice(1).map((intk, i) => {
                        if (
                          intk?.admissionSessionName &&
                          intk?.admissionSessionName != ""
                        ) {
                          return (
                            <div key={i}>
                              {intk?.admissionSessionName}: {intk?.intakeMonth}{" "}
                              {intk?.intakeYear}{" "}
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                )}
              </div>

              {intakeArray.slice(0, 1).map((intk, i) => {
                if (
                  intk?.admissionSessionName &&
                  intk?.admissionSessionName != ""
                ) {
                  return (
                    <span className={styles.card_text_last} key={i}>
                      {intk?.admissionSessionName}: {intk?.intakeMonth}{" "}
                      {intk?.intakeYear}{" "}
                    </span>
                  );
                }
              })}
            </div>
          </li>
        )}

        {exams && exams?.length > 0 && (
          <li>
            <FiFileText className={styles.course_card_icon} />
            <div className={styles.course_card_text}>
              <div className={styles.more_intake_wrapper}>
                <span>Eligibility</span>

                {exams?.length > 1 && (
                  <div className={`${styles.more_intake} relative`}>
                    <span className={styles.more_intake_num}>
                      +{exams.length - 1}
                    </span>
                    <div className="uni-tooltip top">
                      {exams.slice(1).map((exm, i) => {
                        return (
                          <div key={i}>
                            {exm?.exam?.examName}: {exm?.score}{" "}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              {exams.slice(0, 1).map((exm, i) => {
                return (
                  <span className={styles.card_text_last} key={i}>
                    {exm?.exam?.examName}: {exm?.score}{" "}
                  </span>
                );
              })}
            </div>
          </li>
        )}
      </ul>

      <Link legacyBehavior href={link ? link : `#`}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.course_card_link} btn btn-primary`}
        >
          View Details
        </a>
      </Link>
    </div>
  );
};

export default CourseCard;
